import React from 'react';
import { Divider, Paper, Typography } from '@mui/material';
import { MuiTableScrollItems } from 'ui/table/MuiTable';
import { SegmentOperation } from './models/segmentOperationModel';
import { SegmentOperationTable, SegmentRetryOperationButtonClickData } from './SegmentOperationTable';
import { AudienceCardHeader } from './utils/audiencesUI';

export interface SegmentOperationTableCardComponentProps {
    operations: SegmentOperation[];
    scroll: MuiTableScrollItems;
    isLoading: boolean;
    onRetryButtonClick: (data: SegmentRetryOperationButtonClickData) => void;
}

export const SegmentOperationBetaTableCardComponent: React.FC<SegmentOperationTableCardComponentProps> = ({
    operations,
    scroll,
    isLoading,
    onRetryButtonClick
}) => (
    <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
        <AudienceCardHeader>
            <Typography>Bulk changes</Typography>
        </AudienceCardHeader>
        <Divider />
        <SegmentOperationTable
            scroll={scroll}
            data={operations}
            isLoading={isLoading}
            onRetryButtonClick={onRetryButtonClick}
        />
    </Paper>
);
